/**
 * Application Routes Configuration
 * Define all application routes and constants
 */

// ===== PUBLIC ROUTES (accessible without login) =====
export const PUBLIC_ROUTES = {
  LOGIN: "/login",
  PAYMENT: "/payment",
  PAYMENT_SUCCESS: "/payment_success",
  INSURANCE: "/insurance",
};

// ===== AUTH ROUTES (registration pages) =====
export const AUTH_ROUTES = {
  REGISTER: "/register",
  CADDY_REGISTER: "/caddy/register",
  GOLFER_REGISTER: "/golfer/register",
};

// ===== COMMON ROUTES (shared across all user types) =====
export const COMMON_ROUTES = {
  HOME: "/",
  PROFILE: "/profile",
  PAYMENT_FAIL: "/payment_fail",
};

// ===== CADDY ROUTES (caddy specific routes) =====
export const CADDY_ROUTES = {
  LEAVE_SETUP: "/leave_setup",
  JOB_LIST: "/job_list",
  LUCKY_DRAW: "/lucky_draw",
  SCAN_QR: "/scan_qr",
  // "Book me a caddie" offer view, opened from the LINE broadcast deep link.
  TIP_OFFER: "/tip-offer/:id",
};

// ===== GOLFER ROUTES (golfer specific routes) =====
export const GOLFER_ROUTES = {
  BOOK_QR: "/book_qr",
  BOOK_CADDY: "/book_caddy",
  BOOK_CADDY_WITH_ID: "/book_caddy/:id",
  BOOK_CADDY_WITH_BOOKING: "/book_caddy/:id/:booking_id",
  REVIEW: "/review/:id",
  BOOKINGS: "/bookings",
  FAVORITE: "/favorite",
  INSURANCE_APPLY: "/insurance/apply",
  // "Book me a caddie" (internal: tip-offer).
  TIP_OFFER_LIST: "/tip-offer",
  TIP_OFFER_CREATE: "/tip-offer/create",
  TIP_OFFER_DETAIL: "/tip-offer/:id",
};

/**
 * Build the golfer tip-offer ("Book me a caddie") detail path for a given
 * offer id, replacing the `:id` segment in GOLFER_ROUTES.TIP_OFFER_DETAIL.
 * @param {string|number} id
 * @returns {string}
 */
export const buildTipOfferDetailPath = (id) =>
  GOLFER_ROUTES.TIP_OFFER_DETAIL.replace(":id", String(id));

/**
 * Build the golfer's booking page for an existing booking
 * (GOLFER_ROUTES.BOOK_CADDY_WITH_BOOKING). For a booking awaiting payment this
 * is the payment step: summary, coupon, payment countdown and the Ksher hand-off.
 * @param {string|number} caddyId
 * @param {string|number} bookingId
 * @param {{date?: string, time?: string}} [query] - tee date (YYYY-MM-DD) / time (HH:mm)
 * @returns {string}
 */
export const buildBookingPaymentPath = (caddyId, bookingId, query = {}) => {
  const path = GOLFER_ROUTES.BOOK_CADDY_WITH_BOOKING.replace(
    ":id",
    String(caddyId)
  ).replace(":booking_id", String(bookingId));
  const params = new URLSearchParams();
  if (query.date) params.set("date", query.date);
  if (query.time) params.set("time", query.time);
  const qs = params.toString();
  return qs ? `${path}?${qs}` : path;
};

// ===== QUERY PARAMETER CONSTANTS =====
export const QUERY_PARAMS = {
  LOGIN_TYPE: "login_type",
  DATE: "date",
  TIME: "time",
  CADDY_ID: "caddy_id",
  BOOKING_ID: "booking_id",
};

// ===== LOGIN TYPE CONSTANTS =====
export const LOGIN_TYPES = {
  CADDY: 0,
  GOLFER: 1,
};

// Default export
export default {
  PUBLIC_ROUTES,
  AUTH_ROUTES,
  COMMON_ROUTES,
  CADDY_ROUTES,
  GOLFER_ROUTES,
  QUERY_PARAMS,
  LOGIN_TYPES,
};
